import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-busy-spinner',
  templateUrl: './busy-spinner.component.html',
  styleUrls: ['./busy-spinner.component.css']
})
export class BusySpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/services/busy-spinner/busy-spinner.component.ts